import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#ID',
    data: 'TRAINING_ID'
  },
  {
    title: 'วันที่อบรม',
    data: 'TRAINING_DATE'
  },
  {
    title: 'ชื่อหลักสูตร',
    data: 'TRAINING_NAME'
  },
  {
    title: 'รหัสพนักงานวิทยากร',
    data: 'TRAINER_EMPID'
  },
  {
    title: 'ชื่อ-สกุลวิทยากร',
    data: 'TRAINING_INSTRUCTOR'
  },
  {
    title: 'ประเภทวิทยากร',
    data: 'TRAINING_INSTRUCTOR_TYPE'
  },
  {
    title: 'ตำแหน่งผู้เรียน',
    data: 'TRAINING_GROUP_NAME'
  },
  {
    title: 'ฝ่ายงานผู้เรียน',
    data: 'TRAINING_DIVISION'
  },
  {
    title: 'สายงานของผู้เรียน',
    data: 'TRAINING_FIELD'
  },
  {
    title: 'HR ผู้บันทึกข้อมูล',
    data: 'BY'
  },
  {
    title: 'ประเภทการจัดอบรม',
    data: 'TRAINING_PLACE'
  },
  {
    title: 'รูปแบบการจัด',
    data: 'TRAINING_TYPE_V2'
  },
  {
    title: 'หมวดหลักสูตร',
    data: 'TRAINING_GROUP'
  },
  {
    title: 'จำนวนผู้เรียน',
    data: 'TRAINEE_CNT'
  },
  {
    title: 'ชั่วโมงเรียน (เวลาสิ้นสุดลบเวลาเริ่ม)',
    data: 'HOUR'
  },
  {
    title: 'คะแนน PRE AVG (ถ้ามี)',
    data: null,
    render: function (data, type, row) {
      if (row.PRE_AVG && row.TRAINING_TOTAL_SCORE) {
        return (
          parseFloat(row.PRE_AVG).toFixed(2) + ' / ' + row.TRAINING_TOTAL_SCORE
        );
      }
      return '';
    }
  },
  {
    title: 'คะแนน POST AVG (ถ้ามี)',
    data: null,
    render: function (data, type, row) {
      if (row.POST_AVG && row.TRAINING_TOTAL_SCORE) {
        return (
          parseFloat(row.POST_AVG).toFixed(2) + ' / ' + row.TRAINING_TOTAL_SCORE
        );
      }
      return '';
    }
  },
  {
    title: '%ประเมิน',
    data: 'TRAINING_RATING'
  },
  {
    title: 'ค่าวิทยากร',
    data: '1'
  },
  {
    title: 'ค่าห้องอบรม',
    data: '2'
  },
  {
    title: 'ค่าอาหาร',
    data: '3'
  },
  {
    title: 'ค่าเบรค',
    data: '4'
  },
  {
    title: 'ค่ารถบริการ',
    data: '5'
  },
  {
    title: 'ค่าที่พัก',
    data: '6'
  },
  {
    title: 'ค่าอุปกรณ์ หรือของรางวัล',
    data: '7'
  },
  {
    title: 'ค่าอื่นๆ',
    data: '9'
  },
  {
    title: 'รวม [เว้นค่า VT]',
    data: 'TOTAL'
  },
  {
    title: 'ค่า Volunteer',
    data: '8'
  }
];

function reloadTableData(names, page) {
  console.log('reload: ' + names.length);
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(names);
  table.draw();
  table.page(page).draw('page');
  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

class TableReport2 extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.names,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      errMode: 'none',
      scrollX: true
    });

    table.on('page', (event) => {
      var info = table.page.info();
      console.log(info.page);
      this.props.onPageChange(info.page);
    });

    $.fn.dataTable.ext.errMode = 'none';
    // table.columns.adjust();
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    reloadTableData(nextProps.names, nextProps.page);
    return true;
  }

  render() {
    return (
      <div>
        <table
          ref="main"
          className="display nowrap example"
          id={id}
          style={{width: '100%'}}
        />
      </div>
    );
  }
}
export default TableReport2;
